module.exports = __webpack_public_path__ + "img/dot-single.143577c7.svg";